export const FILE_TYPES = {
  CSV: "csv",
  XLSX: "xlsx"
};

export const MIME_TYPES = {
  CSV: "text/csv",
  XLSX: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
};

export const MAX_EXPORT_RECORDS = 2000;

export const EXCLUDED_EXPORT_COLUMNS = ["action", "viewedAt", "attachments"];

export const EXPORT_MENU_IDS = {
  LIST: "saved_lists_export_list",
  CSV: "saved_lists_export_csv",
  XLSX: "saved_lists_export_xlsx"
};

export const DEFAULT_CONTENT_TYPE = "Orders";
export const DEFAULT_CONTENT_KEY = "export_action_completed";
